import React, { useEffect, useRef, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import "./Accordion.css";
import {
  AccordionContent,
  AccordionSection,
  AccordionText,
  AccordionTitle,
  ToggleIcon,
} from "./Accordion.style";

export const Accordion = (props: any) => {
  const [active, setActive] = useState<Boolean>(false);
  const content = useRef<any>(null);
  const [height, setHeight] = useState("0px");

  // useEffect(() => {
  // console.log("Height for ", props.title, ": ", height);
  // console.log("Height for ", props.content, ": ", height);

  // }, [height]);

  // const smt: string = `${content?.current?.scrollHeight}px`;

  function toggleAccordion() {
    setActive(!active);
    setHeight(active ? "0px" : `${content?.current?.scrollHeight}px`);
  }

  return (
    <AccordionSection>
      <div
        className={`accordion ${active ? "activee" : ""}`}
        onClick={toggleAccordion}
      >
        <AccordionTitle>{props.title}</AccordionTitle>
        <ToggleIcon>{active ? <RemoveIcon /> : <AddIcon />}</ToggleIcon>
      </div>
      <AccordionContent ref={content} style={{ maxHeight: `${height}` }}>
        <AccordionText dangerouslySetInnerHTML={{ __html: props.content}}/>
      </AccordionContent>
    </AccordionSection>
  );
};
